import React from 'react';
import './SeasonSelector.css';

export interface SeasonOption {
  key: string;
  label: string;
  hasData: boolean;
}

interface SeasonSelectorProps {
  seasons: SeasonOption[];
  selectedSeason: string;
  onSeasonChange: (seasonKey: string) => void;
}

const SeasonSelector: React.FC<SeasonSelectorProps> = ({ 
  seasons, 
  selectedSeason, 
  onSeasonChange 
}) => {
  return (
    <div className="season-selector">
      <label htmlFor="season-select" className="season-selector-label">
        Valitse kausi:
      </label>
      <select
        id="season-select"
        value={selectedSeason}
        onChange={(e) => onSeasonChange(e.target.value)}
        className="season-select"
      >
        {seasons.map((season) => (
          <option 
            key={season.key} 
            value={season.key}
            disabled={!season.hasData}
          >
            {season.label} {!season.hasData ? '(Ei tietoja)' : ''}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SeasonSelector;

